const getUrlParameter = require(`getUrlParameter`);
const flickity = require(`flickity`);

const usersProfile = (function() {
  const $carousel = $(`.profile-carousel`);

  const editUsersCarousel = function() {
    $(`.profile-carousel .carousel-cell`).css({ width: `100%` });
    $carousel.flickity({
      cellAlign: `left`,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      draggable: false,
    });

    $(`.profile-nav .nav-items .link`).on(`click`, function() {
      let index = $(this).attr(`data-link`),
        slide = $(`.flickity-carousel-item[data-link='${index}']`),
        selectedSlide = $(`.flickity-carousel-item`).index(slide);

      $carousel.flickity(`select`, selectedSlide);
    });

    $(`.billing-page-display`).on(`click`, function() {
      let index = `change-plan`,
        slide = $(`.flickity-carousel-item[data-link='${index}']`),
        selectedSlide = $(`.flickity-carousel-item`).index(slide);

      $carousel.flickity(`select`, selectedSlide);
    });
  };

  const preSelectSlide = function() {
    let index = $(`window`).getUrlParameter(`select`),
      slide = $(`.flickity-carousel-item[data-link='${index}']`),
      selectedSlide = $(`.flickity-carousel-item`).index(slide);

    $carousel.flickity(`select`, selectedSlide, false, true);
  };

  const init = function() {
    editUsersCarousel();
    preSelectSlide();
  };
  return { init };
}());

if ($(`.profile-nav`).length) {
  usersProfile.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/profile/edit-profile.js